
// src/reducers/lambda-api-reducer.js

import { mergeArray, deleteArray } from '../helpers/store'
import moment from 'moment'

import { 
  FETCH_REVIEW,
  FETCH_REVIEW_REQUESTED,
  FETCH_REVIEW_STREAMING,
  FETCH_REVIEW_COMPLETED,
  FETCH_REVIEW_FAILED,
  CLEAR_REVIEW,
  INITIALIZE_REVIEW,
  OPEN_REVIEW_PANEL,
  CLOSE_REVIEW_PANEL
} from '../actions/review'
import actions from '../actions'

const initialState = {
  isFetching: false,
  isFetchFailed: false,
  stream: ['<strong>','💡AIに日報のレビューを依頼できます。</strong>'],
  isOpenReviewPanel: false,
}

export default function lambdaApiReducer(state = initialState, action = {}) {
  switch(action.type) {

  case FETCH_REVIEW_REQUESTED:
    return Object.assign({}, state, {
      isOpenReviewPanel: true,
      isFetching: true,
      isFetchFailed: false,
      stream: [],
    })

  case FETCH_REVIEW_STREAMING:
    return Object.assign({}, state, {
      isOpenReviewPanel: true,
      isFetching: true,
      isFetchFailed: false,
      stream: [...state.stream, action.results],
      type: undefined
    })

  case FETCH_REVIEW_FAILED:
    return Object.assign({}, state, {
      isOpenReviewPanel: true,
      isFetching: false,
      isFetchFailed: true,
      stream: ['エラーが発生しました。もう一度お試しください。'],
    })

  case FETCH_REVIEW_COMPLETED:
    return Object.assign({}, state, {
      isOpenReviewPanel: true,
      isFetching: false,
      isFetchFailed: false,
      isCompleted: true,
    })

  case OPEN_REVIEW_PANEL:
    return Object.assign({}, state, {
      isOpenReviewPanel: true,
      stream: ['<strong>','💡日報を書いてAIにレビューを依頼できます。</strong>'],
    })
  case CLOSE_REVIEW_PANEL:
    return Object.assign({}, state, {
      isOpenReviewPanel: false,
      isCompleted: false,
      stream: ['<strong>','💡日報を書いてAIにレビューを依頼できます。</strong>'],
    })
  case CLEAR_REVIEW:
    return {
      isOpenReviewPanel: true,
      stream: []
    }
  case INITIALIZE_REVIEW:
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/lambda-api-reducer.js